module.exports = "<template> <sio-cell if.bind=_column item.bind=item column.bind=_column></sio-cell> </template> ";